export interface SysIAnalitos {
  An_Id: number;
  An_Tm_Id: number;
  An_Um_Id: number | null;
  An_Ra_Id: number | null;
  An_Cb_Id: number | null;
  An_Tr_Id: ResultTypeResult;
  An_Nombre: string;
  An_Abreviatura: string;
  An_Homologacion: string | null;
  An_ValRefText: string | null;
  An_Decimales: number;
  An_Estado: boolean | null;
  An_RangoExtentido: boolean | null;
  An_Plantilla: string | null;
  TipoMuestra: SysIAnalitosTipoMuestras
}

export interface SysIAnalitosTipoMuestras {
  Tm_Id: number;
  Tm_Color: string;
  Tm_Nombre: string;
  Tm_Descripcion: string | null;
  Tm_Sufijo: string | null;
  Tm_TiempoDescarte: number | null;
  Tm_Estado: boolean;
}

export interface SysIAnalitosResulTipoListas {
  Rtl_Id: number;
  Rtl_An_Id: number;
  Rtl_Resultado: string;
  Rtl_Descripcion: string | null;
  Rtl_Abreviatura: string;
}


export interface SysAAnalitosRangosAlternos {
  Ra_Id: number;
  Ra_Nombre: string;
  Ra_Detalle: string | null;
  Ra_Estado: boolean;
}

export interface SysAAnalitosUnidadesMedida {
  Um_Id: number;
  Um_Nombre: string;
  Um_Sd_Id: number;
  Um_Umb_Id1: number;
  Um_FactorConversion1: string;
  Um_Umb_Id2: number | null; 
  Um_FactorConversion2: string | null; 
}

export interface SysACodigoBarras {
  Cb_Id: number;
  Cb_Nombre: string;
  Cb_CodigoEtiqueta: string;
  Cb_Sufijo: string | null; 
  Cb_Estado: boolean | null;
}


export enum ResultTypeResult {
  NUMERICO = 1,
  TEXTUAL = 2,
  FORMULA = 3,
  PLANTILLA = 4,
  FECHA = 5,
  TIEMPO = 6,
  IMAGEN = 7,
  LISTA = 8,
  MICROBIOLOGIA = 9,
  AUTOCOMPLETAR = 10,  
}

export type typeControl = 'dxAutocomplete'| 'dxDateRangeBox' | 'dxCalendar' | 'dxCheckBox' | 'dxColorBox' | 'dxDateBox' | 'dxDropDownBox' | 'dxHtmlEditor' | 'dxLookup' | 'dxNumberBox' | 'dxRadioGroup' | 'dxRangeSlider' | 'dxSelectBox' | 'dxSlider' | 'dxSwitch' | 'dxTagBox' | 'dxTextArea' | 'dxTextBox';

export interface ConfigPlantillas{
  Group: string,
  KeyValue: string,
  Type: typeControl,
  Label: string,
  Items?: string[];
  ColSpan: number,
}

export enum TypeRules {
  Validaciones = 1,
  ResultadosPropios = 2,
  ResultadosOtrosAnalitos = 3,
  ResultadosTraducciones = 4,
  ValidacionResultados = 5,
}

// Agregar estas interfaces al archivo types.analitos.ts

export interface SysIAnalitosRangosExtendidos {
  Rex_Id: number;
  Rex_An_Id: number;
  Rex_Gn_Id: number; // 0=Ambos, 1=Masculino, 2=Femenino
  Rex_EdadMinima: number;
  Rex_EdadMaxima: number;
  Rex_ValRefMin: number;
  Rex_ValRefMax: number;
  Rex_Estado: boolean;
  
  // Propiedades para facilitar el manejo en el frontend
  Analito?: SysIAnalitos;
}


export interface RangoExtendidoFormData {
  Rex_Id?: number;
  Rex_Gn_Id: number;
  Rex_EdadMinima: number | null;
  Rex_EdadMaxima: number | null;
  Rex_ValRefMin: number | null;
  Rex_ValRefMax: number | null;
  Rex_Estado: boolean;
}

// Interface para los datos de género que vienen de SysI_Genero
export interface SysIGenero {
  Gn_Id: number;
  Gn_Nombre: string;
  Gn_Estado?: boolean;
}

// Interface para validaciones de rangos
export interface RangoValidationResult {
  isValid: boolean;
  errors: string[];
}

// Interface para el estado del modal
export interface ModalRangosExtendidosState {
  visible: boolean;
  loading: boolean;
  saving: boolean;
  rangos: RangoExtendidoFormData[];
  editingRowIndex: number | null;
}

export interface RangoMasivo {
  genero: number;
  edadMinima: number; // Días (para backend)
  edadMaxima: number; // Días (para backend)
  valorMin: number;
  valorMax: number;
  estado: boolean;
}